export interface CalculateValuationState {
  isLoading: boolean | null;
  data: any | null;
}

export const initialState = {
  isLoading: null,
  data: null
};